import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "./style";
import { setUserInfo } from "../../../store/features/UserInfo";
import { Button, Form, Input, Space, Modal, message } from "antd";
import ReactRouterPrompt from "react-router-prompt";
import MockPhone from "../../../components/MockPhone/index";
import PutUpload from "../../../components/PutUpload/index";
import CoachPreview from "../../../components/CoachPreview/index";
import { gql, useMutation } from "@apollo/client";
const { TextArea } = Input;

// const LIST_EXPERTISES = gql`
//   query listExpertises {
//     expertises {
//       _id
//       title
//       backgroundColor
//       linearColor
//       backgroundUrl
//       description
//     }
//   }
// `;

const UPDATE_COACH = gql`
  mutation updateCoach($updateCoachInput: UpdateCoachInput!) {
    updateCoach(updateCoachInput: $updateCoachInput) {
      _id
    }
  }
`;

export default function ProfileEditor() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isChanged, setIsChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tempAvatar, setTempAvatar] = useState("");
  const userInfo = useSelector((state) => state.userInfo.userInfo);

  // Mock challenges data for preview
  const mockChallenges = [
    {
      _id: "1",
      title: "Fitness Transformation",
      description:
        "Transform your body and mind with this intensive 30-day fitness program.",
      numberOfDays: 30,
    },
    {
      _id: "2",
      title: "Healthy Eating Habits",
      description:
        "Learn to develop sustainable healthy eating habits over 30 days.",
      numberOfDays: 30,
    },
  ];
  // const [selectedTags, setSelectedTags] = useState([]);
  // const [expertiseList, setExpertiseList] = useState([]);
  // const [getExpertises, { data }] = useLazyQuery(LIST_EXPERTISES);

  useEffect(() => {
    if (userInfo.coach && userInfo.coach.profile_image) {
      setTempAvatar(userInfo.coach.profile_image);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loading) {
      setIsChanged(false);
    }
  }, [loading]);

  // useEffect(() => {
  //   getExpertises();
  //   if (data) {
  //     const list = data.expertises.map((v) => {
  //       return {
  //         value: v._id,
  //         label: v.title,
  //         backgroundColor: v.backgroundColor,
  //         linearColor: v.linearColor,
  //       };
  //     });
  //     setExpertiseList(list);
  //   }
  // }, [data, getExpertises]);
  // const onSelectTags = (val) => {
  //   setSelectedTags(val);
  // };

  const [updateCoach] = useMutation(UPDATE_COACH);

  // Upload
  const onUpload = (fileUrl, fileInfo) => {
    setTempAvatar(fileUrl);
    console.log("头像上传成功:", fileUrl, fileInfo);
  };

  // Form
  const [form] = Form.useForm();
  const nameValue = Form.useWatch("name", form);
  // const beliefValue = Form.useWatch("belief", form);
  // const expertiseValue = Form.useWatch("expertise", form);
  const aboutValue = Form.useWatch("about", form);
  const socialLinkValue = Form.useWatch("socialLink", form);
  // const experienceValue = Form.useWatch("experience", form);

  const onBack = () => {
    navigate("/ProfileBuilder");
  };

  const onFormChange = () => {
    setIsChanged(true);
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const param = {
        _id: userInfo.coach?._id,
        name: values.name,
        // belief: values.belief,
        profile_image: tempAvatar,
        // expertise: values.expertise.map((v) => v.value),
        about: values.about,
        socialLink: values.socialLink,
        // experience: values.experience,
      };
      await updateCoach({
        variables: {
          updateCoachInput: param,
        },
      });
      const storeParam = { user: userInfo.user, coach: param };
      dispatch(setUserInfo(storeParam));
      message.success("My profile has been updated");
      navigate("/ProfileBuilder");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoading(false);
  };

  return (
    <Container forceRender>
      <ReactRouterPrompt when={isChanged}>
        {({ isActive, onConfirm, onCancel }) =>
          isActive && (
            <Modal
              title="Unsaved changes"
              open
              footer={[
                <div key="flex-between" className="flex-between">
                  <Button
                    key="discard"
                    danger
                    loading={loading}
                    onClick={() => {
                      setIsChanged(false);
                      onConfirm();
                    }}
                  >
                    Discard Changes
                  </Button>
                  <div key="div">
                    <Button key="back" onClick={onCancel}>
                      Cancel
                    </Button>
                    <Button
                      key="save"
                      type="primary"
                      loading={loading}
                      onClick={() => {
                        onFinish();
                        onConfirm();
                      }}
                    >
                      Save Changes
                    </Button>
                  </div>
                </div>,
              ]}
            >
              <p>
                You are about to leave this page with unsaved changes. Would you
                like to save these changes before leaving?
              </p>
            </Modal>
          )
        }
      </ReactRouterPrompt>
      <div className="left-side">
        <div className="page-title">Edit my profile</div>
        <Form
          form={form}
          name="profileForm"
          layout="vertical"
          size="large"
          className="full-width"
          initialValues={userInfo.coach}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={onFormChange}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please input your name" }]}
          >
            <Input placeholder="Input your name" />
          </Form.Item>
          {/* Coach's social link */}
          <Form.Item
            label="Social link"
            name="socialLink"
            rules={[
              { required: true, message: "Please input your social link" },
              {
                type: "url",
                message: "Please enter a valid URL (e.g., https://example.com)",
              },
            ]}
          >
            <Input placeholder="Input your social link (e.g., https://example.com)" />
          </Form.Item>
          {/* <Form.Item label="Headline" name="belief">
            <Input showCount maxLength={50} placeholder="Input your headline" />
          </Form.Item> */}
          <Form.Item label="Upload profile image" name="profile_image">
            <PutUpload
              fileName={`${
                userInfo.coach?._id
              }_${+new Date()}_profile_image.png`}
              onChange={onUpload}
            />
          </Form.Item>
          {/* <Form.Item
            label="Expertise (Please select max 3 items)"
            name="expertise"
            rules={[
              { required: true, message: "Please select your expertises" },
            ]}
          >
            <SelectTags
              initialValues={userInfo.coach?.expertise}
              options={expertiseList}
              onChange={onSelectTags}
            />
          </Form.Item> */}
          <Form.Item
            label="About"
            name="about"
            rules={[{ required: true, message: "Please input about" }]}
          >
            <TextArea
              showCount
              maxLength={1000}
              rows={6}
              placeholder="Input about"
              style={{ resize: "none" }}
            />
          </Form.Item>
          {/* <Form.Item label="Experience" name="experience">
            <TextArea
              showCount
              maxLength={200}
              placeholder="Input your experience"
              style={{ resize: "none" }}
            />
          </Form.Item> */}

          <Form.Item>
            <Space size="middle">
              <Button type="primary" htmlType="submit" loading={loading}>
                Save and publish
              </Button>
              <Button onClick={onBack}>Cancel</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
      <div className="right-side">
        <MockPhone title="About coach" showTabbar>
          <CoachPreview
            coachData={{
              name: nameValue || userInfo.coach?.name,
              profile_image: tempAvatar || userInfo.coach?.profile_image,
              socialLink: socialLinkValue || userInfo.coach?.socialLink,
              about: aboutValue || userInfo.coach?.about,
              subscriberCount:
                userInfo.user?.subscriberCount ||
                userInfo.coach?.subscriberCount,
            }}
            challenges={mockChallenges}
          />
        </MockPhone>
      </div>
    </Container>
  );
}
